import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PostJobForm from '../components/PostJobForm';
import { createJob } from '../services/postJobService';
import CardIcon from '../../../shared/components/icons/CardIcon';

function PostJobPage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async (jobData) => {
    setIsSubmitting(true);

    try {
      const payload = {
        title: jobData.title,
        description: jobData.description,
        skillId: jobData.skillId,
        city: jobData.city,
        area: jobData.area,
        budget: Number(jobData.budget),
        expiresAt: jobData.expiresAt,
        isNegotiable: jobData.isNegotiable,
        urgency: jobData.urgency,
        requiredPeople: Number(jobData.requiredPeople) || 1,
        workType: jobData.workType,
      };

      await createJob(payload);
      toast.success('New job posted successfully!');
      setShowSuccess(true);
      window.setTimeout(() => {
        navigate('/client/jobs');
      }, 1600);
    } catch (error) {
      toast.error(error?.message || 'Unable to post job.');
      setIsSubmitting(false);
    }
  };

  return (
    <section className="space-y-6">
      <div className="rounded-3xl bg-white p-8 shadow-sm">
        <h1 className="flex items-center gap-3 text-3xl font-semibold text-navy"><CardIcon name="briefcase" className="h-7 w-7" />Post a job</h1>
        <p className="mt-2 text-sm text-slate-600">
          Share your vacancy and let candidates contact you directly.
        </p>
      </div>

      <PostJobForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />

      {showSuccess && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 px-4 py-6">
          <div className="w-full max-w-sm rounded-3xl bg-white p-6 text-center shadow-xl">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
              <svg
                className="h-8 w-8"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <h2 className="mt-4 text-xl font-semibold text-navy">Job posted successfully!</h2>
            <p className="mt-2 text-sm text-slate-600">Returning to the feed page shortly…</p>
          </div>
        </div>
      )}
    </section>
  );
}

export default PostJobPage;